export default __webpack_public_path__ + "static/media/no-filter-data.67d041d9.svg";